import {
  accreds,
  besoinTech,
  devisAgent,
  docDesPortes,
  emergencyDoc,
  emergencyUsage,
  folderDynamic,
  folderPC,
  folderSecurity,
  hoursSheet,
  listComity,
  odjAnim,
  odjPleniaire,
  odjPresidence,
  odjTech,
  planningComite,
  planningParSalle,
  posteAgent,
  posteGeneral,
  posteStaffs,
  standsValidator,
  suiviAnim,
} from "./links";
import { defaultJiData } from "./default";
import { UnityData } from "../../../LinkDataInterface";

export const japanImpact2025: UnityData = {
  ...defaultJiData,
  groups: [
    [folderSecurity, folderDynamic, folderPC],
    [emergencyUsage, emergencyDoc, accreds, planningComite],
    [besoinTech, hoursSheet, docDesPortes, devisAgent],
    [odjPleniaire, odjTech, odjAnim, odjPresidence],
    [posteGeneral, posteStaffs, posteAgent],
    [suiviAnim, planningParSalle, listComity, standsValidator],
  ],
};
